import "core-js/modules/es6.array.map";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.filter";
import r, { useContext as u } from "react";
import { PrimaryNavContext as c } from "./PrimaryNavContext";
import { getFirstNameLastInitial as p } from "./helpers/user";

var _ = function _(_ref) {
  var o = _ref.isMobile;
  var s, t;

  var _u = u(c),
      n = _u.authenticatedUser,
      e = _u.menuData,
      a = _u.logoutAction;

  return r.createElement(r.Fragment, null, n && r.createElement("h2", {
    id: "my-account".concat(o ? "-mobile" : ""),
    className: "hg-primarynav__menu-header"
  }, p(n)), r.createElement("ul", {
    className: "hg-primarynav__useractions-list",
    "aria-labelledby": "my-account".concat(o ? "-mobile" : "")
  }, (t = (s = e == null ? void 0 : e.userActions) == null ? void 0 : s.filter(function (_ref2) {
    var i = _ref2.name;
    return i !== "log-in";
  })) == null ? void 0 : t.map(function (_ref3) {
    var i = _ref3.label,
        m = _ref3.url,
        l = _ref3.name;
    return r.createElement("li", {
      key: i,
      className: "hg-primarynav__useractions-list-item"
    }, r.createElement("a", {
      href: m,
      className: "hg-primarynav__useractions-link",
      onClick: l === "log-out" ? a : void 0
    }, i));
  })));
};

export { _ as UserActionsMenu };